import categories from './categories';
import fields from './fields';

export default {
  /**
   * Set up the Algolia credentials
   */
  algolia_app_id: '8VOK4WOPYE',
  algolia_api_key: 'a32630f310e8bde72e07a235bdadda86',
  algolia_index: 'INSIDECOLUMBIA-DOCS',

  /**
   * Set up Analytics info for tracking survey responses
   */
  analytics_id: 'UA-130768066-32',

  /**
   * Set up the Google Sheet information so it can make requests to the right place
   */
  google_sheet_title: 'INSIDECOLUMBIA-Docs-2020-DB',

  /**
   * The expiration date of the survey, where no more submissions will be accepted
   * Format: 'July 3, 2018'
   */
  expiration_date: 'August 9, 2022',

  /**
   * Set some variables for the display of the survey
   */
  survey_title: 'Inside Columbia Top Doctors - 2020',
  survey_subtitle: null,
  social_title: 'Cast your vote for the Top Doctor!',
  publication_logo: 'https://s3-us-west-2.amazonaws.com/docs.insidecolumbiavoting.com/insidecolumbia_logo.png',
  welcome_title: 'Welcome!',
  welcome: 'Show your appreciation and respect for your peers. Winners will receive editorial mention, which is good for them and their practices. Your vote will help us create a reputable, well-rounded list that will be valuable to our readers. This is a peer-voted list, we can\'t do it without you!<br><br><span class="has-text-danger">The deadline for all nominations is November 18th, 2019.</span>',
  rules: [
    'If you vote for yourself in any category, you must vote for at least two candidates outside your practice in that same category.',
    'You may only submit one ballot per year.',
    'Only vote for a professional if you have personally witnessed his/her skill and expertise.',
    'You must practice within the greater Columbia area.',
  ],
  categories,
  fields,
  votes_per_category: 3,
  write_in_limit: 10,
  vote_requirement: 1,
  project_id: 11,
};
